// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.inline_SOQV6 {
  position : static;
  height:100%;
  width: 100%;
  display : inline-flex;
  align-items : center;
  border : 0 solid transparent !important;
  border-radius: 0 !important;
}

.inlineDetail_qoewb {
  justify-content: inherit;
  align-items: inherit;
  position: relative;
}

.inlineDetail_qoewb.editing_mHqRd {
  width: 100%;
  justify-content: flex-end;
}

.inlineTable_texWJ:has([data-editable]):hover::before, .inlineTable_texWJ[data-editable="true"]:hover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border : var( --size-attributeCellEditable, 1px ) var( --color-attributeCellEditable, var( --color-cellEditorFocus, var( --color-brand500, #2323c3 ) ) ) solid !important;
  z-index:10000;
  pointer-events: none;
}

.inlineDetail_qoewb[data-editable="true"] > :first-child {
  position: relative;
}

.inlineDetail_qoewb[data-editable="true"]:not(.renderer_HPpcv):hover::before, .inlineDetail_qoewb[data-editable="true"].renderer_HPpcv > :first-child:hover:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border : var( --size-attributeCellEditable, 1px ) var( --color-attributeCellEditable, var( --color-cellEditorFocus, var( --color-brand500, #2323c3 ) ) ) solid !important;
  z-index:10000;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/attribute/editor/InlineEditor.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yKAAyK;EACzK,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yKAAyK;EACzK,aAAa;EACb,oBAAoB;AACtB","sourcesContent":["\n.inline {\n  position : static;\n  height:100%;\n  width: 100%;\n  display : inline-flex;\n  align-items : center;\n  border : 0 solid transparent !important;\n  border-radius: 0 !important;\n}\n\n.inlineDetail {\n  justify-content: inherit;\n  align-items: inherit;\n  position: relative;\n}\n\n.inlineDetail.editing {\n  width: 100%;\n  justify-content: flex-end;\n}\n\n.inlineTable:has([data-editable]):hover::before, .inlineTable[data-editable=\"true\"]:hover::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border : var( --size-attributeCellEditable, 1px ) var( --color-attributeCellEditable, var( --color-cellEditorFocus, var( --color-brand500, #2323c3 ) ) ) solid !important;\n  z-index:10000;\n  pointer-events: none;\n}\n\n.inlineDetail[data-editable=\"true\"] > :first-child {\n  position: relative;\n}\n\n.inlineDetail[data-editable=\"true\"]:not(.renderer):hover::before, .inlineDetail[data-editable=\"true\"].renderer > :first-child:hover:before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border : var( --size-attributeCellEditable, 1px ) var( --color-attributeCellEditable, var( --color-cellEditorFocus, var( --color-brand500, #2323c3 ) ) ) solid !important;\n  z-index:10000;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inline": `inline_SOQV6`,
	"inlineDetail": `inlineDetail_qoewb`,
	"editing": `editing_mHqRd`,
	"inlineTable": `inlineTable_texWJ`,
	"renderer": `renderer_HPpcv`
};
export default ___CSS_LOADER_EXPORT___;
